"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const Modal_1 = __importDefault(require("@mui/material/Modal"));
const Button_1 = __importDefault(require("@mui/material/Button"));
function default_1({ openModal, setOpenModal, }) {
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    return ((0, jsx_runtime_1.jsx)(Modal_1.default, Object.assign({ open: openModal, slotProps: { backdrop: { sx: { bgcolor: maxWidth768 ? 'transparent' : 'var(--gray-80)' } } }, sx: {
            display: 'block',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: maxWidth768 ? '800px' : '480px',
            height: maxWidth768 ? 'unset' : '720px',
            margin: 'auto',
            bgcolor: 'var(--white)',
        } }, { children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("img", { src: '/static/user/res/promise.gif', css: { width: '100%', borderRadius: '4px 4px 0 0' } }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "surface-white", css: {
                            position: 'absolute',
                            width: '100%',
                            bottom: 0,
                            padding: 20,
                            borderRadius: '0 0 4px 4px',
                        } }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ sx: {
                                height: '50px',
                                p: '6px',
                                borderRadius: '4px',
                                bgcolor: 'var(--secondary-main) !important',
                                color: 'var(--white)',
                                fontSize: '16px',
                                fontWeight: 700,
                            }, fullWidth: true, onClick: () => setOpenModal(false) }, { children: "\uD655\uC778\uD588\uC5B4\uC694!" })) }))] }) }) })));
}
exports.default = default_1;
